import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';

class ToolFrameOpenList extends Tool {
  static toolName = 'Open frame list';

  static action({ controller }: IToolActionInput) {
    controller.actionOpenSidePanel('frames');
  }

  static enabled({ controller }: IToolEnabledInput) {
    return !!controller.hasFrames();
  }
}

export default ToolFrameOpenList;
